export default {
  gotoTab: e => {
    const { target } = e
    const link = document.getElementById(target.getAttribute('href'))
    if (link) {
      e.preventDefault()
      link.click()
      return false
    }
  },

  getAdminAcronym: ({ name }) => {
    if (name) {
      return name.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '')
    } else {
      return 'N/A'
    }
  },

  getAdminNameAndDate: args => {
    const { createdAt, name } = args
    return `${name}    ${createdAt}`
  },

  getAccessText: (isBankUser) => {
    return `${isBankUser ? 'Bank' : 'SmartBiz'} Viewable only`
  },

  getEditorTitle: ( questionStatus, isEditDraft ) => {
    if (questionStatus === 'new_question') {
      return 'Question'
    } else if (questionStatus === 'reply_question' || questionStatus === 'edit_reply') {
      return 'Reply'
    } else if (questionStatus === 'edit_question') {
      return 'Edit'
    } else {
      return isEditDraft ? 'Edit Draft' : 'Topic & Explanation'
    }
  },

  getPlaceholderText: questionStatus => {
    const placeholderText = questionStatus.includes('reply') ? 'reply' : (questionStatus.includes('question') ? 'question' : 'topic')
    return `Type your ${placeholderText} here`
  },

  hideEditorTitle: questionStatus => {
    return ['new_question', 'reply_question', 'edit_question', 'edit_reply'].includes(questionStatus)
  },

  customBlockStyleFn: contentBlock => {
    if (contentBlock.getType() === 'unstyled') {
      return 'newParagraph'
    }
  },

  getTooltipBottomEdge: tooltipText => {
    if (tooltipText.length > 120) {
      return 48
    } else {
      return 13
    }
  }
}
